module.exports = {
  messages: {
    CN: {
      header: {
        preview: '预览草稿',
        save: '保存草稿',
        publish: '发布',
        surepublish: '确认要发布吗？'
      },
      left: {
        publicComponent: '公共组件',
        pcComponent: 'pc端专用组件',
        pcmenubar: '菜单栏',
        pcfooter: '页脚',
        navbar: '导航栏',
        notice: '公告栏',
        swiper: '轮播图',
        banner: '广告图',
        goodslist: '商品列表',
        spacing: '模块间距',
        mobileComponent: '移动端专用组件',
        index: '锚点组件',
        news: '新闻列表'
      },
      right: {
        floor: '楼层',
        floorManager: '楼层管理',
        clarAll: '清除所有组件',
        empty: '没有组件，这里空空如也~'
      }
    },
    HK: {
      header: {
        preview: '預覽',
        save: '保存並繼續',
        publish: '發布'
      }
    },
    US: {
      header: {
        preview: 'Preview',
        save: 'Save and continue',
        publish: 'Publishing'
      }
    },
    JP: {
      header: {
        preview: 'ドラフトをプレビュー',
        save: 'ドラフトを保存',
        publish: '公開',
        surepublish: '公開してもよろしいですか？'
      },
      left: {
        publicComponent: '共通コンポーネント',
        pcComponent: 'PCサイト専用コンポーネント',
        pcmenubar: 'メニューバー',
        pcfooter: 'フッター',
        navbar: 'ナビゲーションバー',
        notice: 'アナウンスメントバー',
        swiper: 'スライダー',
        banner: '広告画像',
        goodslist: '商品リスト',
        spacing: 'モジュール間のスペース',
        mobileComponent: 'モバイル端末専用コンポーネント',
        index: 'アンカーコンポーネント',
        news: 'ニュースリスト'
      },
      right: {
        floor: 'フロア',
        floorManager: 'フロア管理',
        clarAll: '全てのコンポーネントをクリア',
        empty: 'コンポーネントがありません~'
      }
    }
  }
};